export default __webpack_public_path__ + "static/media/Vision-mission.4ec17ea6.jpeg";